import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { Allroutes } from "./components/routes/route";
import "./index.css";
import { AcademyProvider } from "./views/Academy/AcademyContext";

function App() {
  return (
    <>
      <HashRouter>
        <AcademyProvider>
          <Routes>
            {Allroutes.map((route, i) => (
              <Route key={i} path={route.path} element={<route.component />} />
            ))}
            console.log("App is mounting");
          </Routes>
        </AcademyProvider>
      </HashRouter>
    </>
  );
}

export default App;
